import React from "react";

const Header = ({ invoiceId, country, setCountry }) => {
  return (
    <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center mb-8 p-6 bg-gradient-to-r from-indigo-50 to-purple-50 rounded-2xl border border-indigo-100">
      <div className="mb-4 lg:mb-0">
        <div className="flex items-center space-x-3 mb-3">
          <div className="w-3 h-3 bg-green-500 rounded-full animate-pulse"></div>
          <h2 className="text-lg font-semibold text-gray-700">
            Invoice ID: <span className="text-indigo-700 font-bold">{invoiceId}</span>
          </h2>
        </div>
        <div className="bg-white rounded-lg shadow-sm border border-indigo-100 p-3">
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Cabinet Type
          </label>
          <select
            value={country}
            onChange={(e) => setCountry(e.target.value)}
            className="w-full bg-transparent border-none focus:ring-2 focus:ring-indigo-500 rounded-lg text-gray-700 font-medium"
          >
            <option value="Custom">Custom Cabinets</option>
            <option value="Shaker">Shaker Series</option>
          </select>
        </div>
      </div>
      
      <div className="text-center lg:text-right">
        <div className="bg-white rounded-2xl p-4 shadow-lg border border-indigo-100">
          <img
            src="/assets/Images/logoimg.png"
            alt="Laminance Logo"
            className="h-12 mx-auto lg:mx-0 lg:ml-auto"
          />
          <div className="mt-3 space-y-1">
            <p className="text-sm font-semibold text-gray-700">
              418 Rt 23, Franklin, NJ, 07416
            </p>
            <p className="text-sm font-semibold text-indigo-600">
              Phone: (862) 450-6069
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;